import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import QuickLinks from "./components/QuickLinks";
import WhyChooseUs from "./components/WhyChooseUs";
import NewsSection from "./components/News";
import Events from "./components/Events";
import Testimonials from "./components/Testimonials";
import Gallery from "./components/Gallery";
import TourVideo from "./components/TourVideo";
import Schools from "./components/Schools";
import ContactSection from "./components/Contact";
import StakeHolders from "./components/StakeHolders";
import Footer from "./components/Footer";
import VisionMission from "./components/VisionMission";
import About from "./pages/About";
import Academics from "./pages/Academics";
import Admissions from "./pages/Admissions";
import JournalIssues from "./pages/JournalIssues.js";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import NotFounds from "./pages/NotFounds";
import AdminNews from "./pages/AdminNews";
import Rector from "./components/Rector.js";

import PortalPage from "./pages/PortalPage";
import AlumniPage from "./pages/AlumniPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import LibraryPage   from "./pages/LibraryPage";
import TetfundsP from "./pages/TetfundsP.js";
import Consults from "./pages/Consults";
import GalleryPage from "./components/GalleryPage.js";
import AdminEvents from "./pages/AdminEvents.js";
import ManageEvents from "./pages/adxm/ManageEvents.js"
import AdminNewsList from "./pages/admin/AdminNewsList";
import AdminNewsForm from "./pages/admin/AdminNewsForm";
import AdminEventsList from "./pages/admin/AdminEventsList";
import AdminEventsForm from "./pages/admin/AdminEventsForm";

import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLogin from "./pages/adxm/AdminLogin";
import AdminDashboard from "./pages/adxm/AdminDashboard";
import NoticesManager from "./pages/adxm/NoticesManager";
import StarterCmsManager from "./pages/adxm/StarterCmsManager";
import SupportTicketsManager from "./pages/adxm/SupportTicketsManager";

import NoticeBoard from "./pages/public/NoticeBoard";
import NoticeDetail from "./pages/public/NoticeDetail";
import NoticeAlertBar from "./components/NoticeAlertBar";
import GlobalMegaMenu from "./components/GlobalMegaMenu";
import ProgrammeFinder from "./pages/public/ProgrammeFinder";
import AdmissionEligibilityChecker from "./pages/public/AdmissionEligibilityChecker";
import DownloadCenter from "./pages/public/DownloadCenter";
import StaffDirectory from "./pages/public/StaffDirectory";
import HelpDesk from "./pages/public/HelpDesk";
import CampusMap from "./pages/public/CampusMap";
import SiteSearch from "./pages/public/SiteSearch";
import AdvancedSearch from "./pages/public/AdvancedSearch";
import DepartmentsDirectory from "./pages/public/DepartmentsDirectory";
import DepartmentDetail from "./pages/public/DepartmentDetail";

import InstitutionalDirectory from "./pages/public/InstitutionalDirectory";
import InstitutionalDetail from "./pages/public/InstitutionalDetail";
import AdminInstitutionalPageList from "./pages/admin/AdminInstitutionalPageList";
import AdminInstitutionalPageForm from "./pages/admin/AdminInstitutionalPageForm";
import AdminDepartmentList from "./pages/admin/AdminDepartmentList";
import AdminDepartmentForm from "./pages/admin/AdminDepartmentForm";
import AdminDownloadList from "./pages/admin/AdminDownloadList";
import AdminDownloadForm from "./pages/admin/AdminDownloadForm";
import AdminStaffList from "./pages/admin/AdminStaffList";
import AdminStaffForm from "./pages/admin/AdminStaffForm";
import StaffDetail from "./pages/public/StaffDetail";
import MediaGallery from "./pages/public/MediaGallery";
import VirtualTour from "./pages/public/VirtualTour";
import AdminCampusLocationList from "./pages/admin/AdminCampusLocationList";
import AdminCampusLocationForm from "./pages/admin/AdminCampusLocationForm";
import AdminGalleryAlbumList from "./pages/admin/AdminGalleryAlbumList";
import AdminGalleryAlbumForm from "./pages/admin/AdminGalleryAlbumForm";
import AdminGalleryMediaList from "./pages/admin/AdminGalleryMediaList";
import AdminGalleryMediaForm from "./pages/admin/AdminGalleryMediaForm";
import ResearchPortal from "./pages/public/ResearchPortal";
import ResearchResourcePage from "./pages/public/ResearchResourcePage";
import JournalIssueDetail from "./pages/public/JournalIssueDetail";
import JournalArticleDetail from "./pages/public/JournalArticleDetail";
import AdminJournalIssueList from "./pages/admin/AdminJournalIssueList";
import AdminJournalIssueForm from "./pages/admin/AdminJournalIssueForm";
import AdminJournalArticleList from "./pages/admin/AdminJournalArticleList";
import AdminJournalArticleForm from "./pages/admin/AdminJournalArticleForm";
import AlumniPortal from "./pages/public/AlumniPortal";
import AlumniDetail from "./pages/public/AlumniDetail";
import PartnershipsPage from "./pages/public/PartnershipsPage";
import ProjectTracker from "./pages/public/ProjectTracker";
import ProjectDetail from "./pages/public/ProjectDetail";
import AdminAlumniList from "./pages/admin/AdminAlumniList";
import AdminAlumniForm from "./pages/admin/AdminAlumniForm";
import AdminPartnershipList from "./pages/admin/AdminPartnershipList";
import AdminPartnershipForm from "./pages/admin/AdminPartnershipForm";
import AdminProjectList from "./pages/admin/AdminProjectList";
import AdminProjectForm from "./pages/admin/AdminProjectForm";
import SEOManager from "./components/SEOManager";
import PageAnalytics from "./components/PageAnalytics";
import AccessibilityToolbar from "./components/AccessibilityToolbar";
import AdminSeoPageList from "./pages/admin/AdminSeoPageList";
import AdminSeoPageForm from "./pages/admin/AdminSeoPageForm";
import AdminAnalyticsDashboard from "./pages/admin/AdminAnalyticsDashboard";
import SitemapPage from "./pages/public/SitemapPage";
import AdminSecurityDashboard from "./pages/admin/AdminSecurityDashboard";
import AdminAuditLogs from "./pages/admin/AdminAuditLogs";
import AdminBackupRestore from "./pages/admin/AdminBackupRestore";
import AdminUsersList from "./pages/admin/AdminUsersList";
import AdminUserForm from "./pages/admin/AdminUserForm";
import AdminNavigationList from "./pages/admin/AdminNavigationList";
import AdminNavigationForm from "./pages/admin/AdminNavigationForm";
import AdminContentApprovals from "./pages/admin/AdminContentApprovals";
import AdminSearchInsights from "./pages/admin/AdminSearchInsights";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PerformanceEnhancer from "./components/PerformanceEnhancer";
import ResponsiveLayoutEnhancer from "./components/ux/ResponsiveLayoutEnhancer";
import AdminUiUxCenter from "./pages/admin/AdminUiUxCenter";


// Department Pages
import AgriculturalEngineering from "./pages/departments/AgriculturalEngineering";
import ChemicalEngineering from "./pages/departments/ChemicalEngineering";
import CivilEngineering from "./pages/departments/CivilEngineering";
import ComputerEngineering from "./pages/departments/ComputerEngineering";
import ElectricalEngineering from "./pages/departments/ElectricalEngineering";
import MechanicalEngineering from "./pages/departments/MechanicalEngineering";
import RenewableEnergyEngineering from "./pages/departments/RenewableEnergyEngineering";
import AgricTech from "./pages/departments/AgricTech"; 
import FoodScience from "./pages/departments/FoodScience";
import Environmental from "./pages/departments/Environmental";
import ArchiTech from "./pages/departments/ArchiTech";
import ArtificialIntelligent from "./pages/departments/ArtificialIntelligent";
import ComputerScience from "./pages/departments/ComputerScience";
import Estate from "./pages/departments/Estate";
import CropProduction from "./pages/departments/CropProduction";
import CyberSecurity from "./pages/departments/CyberSecurity";
import FilmMedia from "./pages/departments/FilmMedia";
import Horticultural from "./pages/departments/Horticultural";
import LivestockAnimalProduction from "./pages/departments/LivestockAnimalProduction";
import JournalStudies from "./pages/departments/JournalStudies";
import NetworkingCloud from "./pages/departments/NetworkingCloud";
import OfficeTech from "./pages/departments/OfficeTech";
import Quantity  from "./pages/departments/Quantity";
import SoftwareWeb from "./pages/departments/SoftwareWeb";
import Strategic from "./pages/departments/Strategic";
import Surveying from "./pages/departments/Surveying";
import Urban from "./pages/departments/Urban";
import BuildingTech  from "./pages/departments/BuildingTech";
import SocialS from "./pages/departments/SocialS";
import ScienceLab from "./pages/departments/ScienceLab.js";
//Basic & General Studies Pages
import Mathematics from "./pages/departments/Mathematics";
import Languages from "./pages/departments/Languages";
import LegalStudies from "./pages/departments/LegalStudies";
import Accountancy from "./pages/departments/Accountancy";
import BankingFinance from "./pages/departments/BankingFinance";
import BusinessAdmin from "./pages/departments/BusinessAdmin";
import Marketing from "./pages/departments/Marketing";
import PublicAdministration from "./pages/departments/PublicAdministration";
import LibraryScience from "./pages/departments/LibraryScience";
import MassCommunication from "./pages/departments/MassCommunication";
import HospitalityManagement from "./pages/departments/HospitalityManagement";
import NutritionDietetics from "./pages/departments/NutritionDietetics";
import Statistics from "./pages/departments/Statistics";
import TourismManagement from "./pages/departments/TourismManagement";
import Taxation from "./pages/departments/Taxation";
import Procurement from "./pages/departments/Procurement";
import ScienceLabBio from "./pages/departments/ScienceLabBio";
import ScienceLabChem from "./pages/departments/ScienceLabChem";
import ScienceLabPhy from "./pages/departments/ScienceLabPhy";
import HealthInfo from "./pages/departments/HealthInfo.js";

//Center Pages
import CareerCenter from "./pages/centers/CareerCenter";
import EnterpreneurshipCenter from "./pages/centers/EnterpreneurshipCenter";
import ElearningCenter from "./pages/centers/ElearningCenter";
import ClimateCenter from "./pages/centers/ClimateCenter";
import MedicalCenter from "./pages/centers/MedicalCenter";
import UniversityCenter from "./pages/centers/UniversityCenter";

//Units Pages
import CorruptionUnit from "./pages/units/CorruptionUnit";
import PlanningUnit from "./pages/units/PlanningUnit";
import RegistryUnit from "./pages/units/RegistryUnit";
import ServicomUnit from "./pages/units/ServicomUnit";
import SecurityUnit from "./pages/units/SecurityUnit";
import PolytechnicUnit from "./pages/units/PolytechnicUnit";
import BursaryUnit from "./pages/units/BursaryUnit";
import RectorUnit from "./pages/units/RectorUnit";


//Directorates Pages
import DirectorateofCommunication from "./pages/directorates/DirectorateofCommunication";
import DirectorateofDce from "./pages/directorates/DirectorateofDce";
import DirectorateofGender from "./pages/directorates/DirectorateofGender";
import DirectorateofIts from "./pages/directorates/DirectorateofIts";
import DirectorateofTechnical from "./pages/directorates/DirectorateofTechnical";
import DirectorateofTetfund from "./pages/directorates/DirectorateofTetfund";
import DirectorateofProcurement from "./pages/directorates/DirectorateofProcurement";
import DirectorateofAPU from "./pages/directorates/DirectorateofAPU";
import DirectorateofIPU from "./pages/directorates/DirectorateofIPU";
import DirectorateofPPD from "./pages/directorates/DirectorateofPPD";
import DirectorateofWork from "./pages/directorates/DirectorateofWork";



import TetfundProjectsEnhanced from "./pages/public/TetfundProjectsEnhanced";
import TetfundProjectDetailEnhanced from "./pages/public/TetfundProjectDetailEnhanced";
function AppShell() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/adxm');

  return (
    <>
      {!isAdminRoute && <a href="#main-content" className="skip-link">Skip to main content</a>}
      <SEOManager />
      {!isAdminRoute && <PageAnalytics />}
      {!isAdminRoute && <PerformanceEnhancer />}
      {!isAdminRoute && <ResponsiveLayoutEnhancer />}
      {!isAdminRoute && <Header />}
      {!isAdminRoute && <GlobalMegaMenu />}
      {!isAdminRoute && <NoticeAlertBar />}
      <div id="main-content" tabIndex="-1" />

      <Routes>
        {/* Main Landing Page */}
        <Route
          path="/"
          element={
            <>
              <HeroSlider />
              <main className="flex-grow">
                <QuickLinks />
                <WhyChooseUs />
                <Rector />
                <VisionMission />
                <NewsSection />
                <Events />
                <Testimonials />
                <Gallery />
                <TourVideo />
                <Schools />
                <ContactSection />
                <StakeHolders />
              </main>
            </>
          }
        />

        {/* Engineering */}
        <Route path="/agricultural-and-bio-environmental-engineering" element={<AgriculturalEngineering />} />
        <Route path="/chemical-engineering" element={<ChemicalEngineering />} />
        <Route path="/civil-engineering" element={<CivilEngineering />} />
        <Route path="/computer-engineering" element={<ComputerEngineering />} />
        <Route path="/electrical-engineering" element={<ElectricalEngineering />} />
        <Route path="/mechanical-engineering" element={<MechanicalEngineering />} />
        <Route path="/renewable-energy-engineering" element={<RenewableEnergyEngineering />} />
        <Route path="/agricultural-technology" element={<AgricTech />} />
        <Route path="/food-science-and-technology" element={<FoodScience />} />
        <Route path="/environmental-science-and-management" element={<Environmental />} />
        <Route path="/architectural-technology" element={<ArchiTech />} />
        <Route path="/artificial-intelligence-technology" element={<ArtificialIntelligent />} />
        <Route path="/computer-science" element={<ComputerScience />} />
        <Route path="/estate-management-and-valuation" element={<Estate />} />
        <Route path="/crop-production-technology" element={<CropProduction />} />
        <Route path="/cyber-security-and-data-protection" element={<CyberSecurity />} />
        <Route path="/film-and-media-studies" element={<FilmMedia />} />
        <Route path="/horticulture-and-landscape-technology" element={<Horticultural />} />
        <Route path="/livestock-and-animal-production-technology" element={<LivestockAnimalProduction />} />
        <Route path="/journalism-and-media-studies" element={<JournalStudies />} />
        <Route path="/networking-and-cloud-computing" element={<NetworkingCloud />} />
        <Route path="/office-of-technology-management" element={<OfficeTech />} />
        <Route path="/quantity-surveying" element={<Quantity />} />
        <Route path="/software-and-web-development" element={<SoftwareWeb />} />
        <Route path="/strategic-communication-and-media-studies" element={<Strategic />} />
        <Route path="/surveying-and-geoinformatics" element={<Surveying />} />
        <Route path="/urban-and-regional-planning" element={<Urban />} />
        <Route path="/building-technology" element={<BuildingTech />} />
        <Route path="/social-sciences" element={<SocialS />} />
        <Route path="/taxation" element={<Taxation />} />
        <Route path="/science-laboratory-technology" element={<ScienceLab />} />
        <Route path="/science-laboratory-technology-biological-sciences-" element={<ScienceLabBio />} />
        <Route path="/science-laboratory-technology-chemical-sciences-" element={<ScienceLabChem />} />
        <Route path="/science-laboratory-technology-physics-" element={<ScienceLabPhy />} />
        <Route path="/health-information-management-technology" element={<HealthInfo />} />
        <Route path="/procurement-and-supply-chain-management" element={<Procurement />} />

        {/* Basic & General Studies */}
        <Route path="/mathematics" element={<Mathematics />} />
        <Route path="/languages" element={<Languages />} />
        <Route path="/legal-studies" element={<LegalStudies />} />

        {/* Financial Studies */}
        <Route path="/accountancy" element={<Accountancy />} />
        <Route path="/banking-and-finance" element={<BankingFinance />} />
        <Route path="/business-administration-and-management" element={<BusinessAdmin />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/public-administration" element={<PublicAdministration />} />

        {/* ICT */}
        <Route path="/library-and-information-science" element={<LibraryScience />} />
        <Route path="/mass-communication" element={<MassCommunication />} />

        {/* Applied & Natural Science */}
        <Route path="/hospitality-management" element={<HospitalityManagement />} />
        <Route path="/nutrition-and-dietetics" element={<NutritionDietetics />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/tourism-management-technology" element={<TourismManagement />} />

        {/* Centers */}
        <Route path="/career-development-center" element={<CareerCenter />} />
        <Route path="/enterpreneurship-center" element={<EnterpreneurshipCenter />} />
        <Route path="/center-for-open-distance-e-learning-codel" element={<ElearningCenter />} />
        <Route path="/climate-change-environmental-sustainability-center" element={<ClimateCenter />} />
        <Route path="/medical-center" element={<MedicalCenter />} />
        <Route path="/university-affiliation-center" element={<UniversityCenter />} />
        <Route path="/centers/career-development-center" element={<CareerCenter />} />
        <Route path="/centers/enterpreneurship-center" element={<EnterpreneurshipCenter />} />
        <Route path="/centers/entrepreneurship-center" element={<EnterpreneurshipCenter />} />
        <Route path="/centers/center-for-open-distance-e-learning-codel" element={<ElearningCenter />} />
        <Route path="/centers/climate-change-environmental-sustainability-center" element={<ClimateCenter />} />
        <Route path="/centers/medical-center" element={<MedicalCenter />} />
        <Route path="/centers/university-affiliation-center" element={<UniversityCenter />} />

        {/* Units */}
        <Route path="/anti-corruption-and-transparency-monitoring-unit-actu-" element={<CorruptionUnit />} />
        <Route path="/planning-unit" element={<PlanningUnit />} />
        <Route path="/registry-unit" element={<RegistryUnit />} />
        <Route path="/servicom-unit" element={<ServicomUnit />} />
        <Route path="/Bursary-Unit" element={<BursaryUnit />} />
        <Route path="/security-unit" element={<SecurityUnit />} />
        <Route path="/polytechnic-legal-unit" element={<PolytechnicUnit />} />
        <Route path="/Rectory-unit" element={<RectorUnit/>}/>
        <Route path="/bursary-unit" element={<BursaryUnit />} />
        <Route path="/rectory-unit" element={<RectorUnit />} />
        <Route path="/units/anti-corruption-and-transparency-monitoring-unit-actu-" element={<CorruptionUnit />} />
        <Route path="/units/planning-unit" element={<PlanningUnit />} />
        <Route path="/units/registry-unit" element={<RegistryUnit />} />
        <Route path="/units/servicom-unit" element={<ServicomUnit />} />
        <Route path="/units/bursary-unit" element={<BursaryUnit />} />
        <Route path="/units/security-unit" element={<SecurityUnit />} />
        <Route path="/units/polytechnic-legal-unit" element={<PolytechnicUnit />} />
        <Route path="/units/rectory-unit" element={<RectorUnit />} />

        {/* Directorates */}
        <Route path="/directorate-of-communication-and-related-matters" element={<DirectorateofCommunication />} />
        <Route path="/directorate-of-continuing-education-dce-" element={<DirectorateofDce />} />
        <Route path="/directorate-for-teaching-and-vocational-education-and-training" element={<DirectorateofTechnical />} />
        <Route path="/directorate-of-tetfund-intervention-and-other-grants" element={<DirectorateofTetfund />} />
        <Route path="/directorate-of-gender-issues" element={<DirectorateofGender />} />
        <Route path="/directorate-of-information-and-technological-services-its-" element={<DirectorateofIts />} />
        <Route path="/directorate-of-public-procurement" element={<DirectorateofProcurement />} />
        <Route path="/directorate-of-physical-planning-and-development-ppd-" element={<DirectorateofPPD />} />
        <Route path="/directorate-of-works-and-services" element={<DirectorateofWork />} />
        <Route path="/directorate-of-academic-planning-unit" element={<DirectorateofAPU />} />
        <Route path="/directorate-of-student-industrial-placement-unit-ipu-" element={<DirectorateofIPU />} />
        <Route path="/directorates/directorate-of-communication-and-related-matters" element={<DirectorateofCommunication />} />
        <Route path="/directorates/directorate-of-continuing-education-dce-" element={<DirectorateofDce />} />
        <Route path="/directorates/directorate-for-teaching-and-vocational-education-and-training" element={<DirectorateofTechnical />} />
        <Route path="/directorates/directorate-of-tetfund-intervention-and-other-grants" element={<DirectorateofTetfund />} />
        <Route path="/directorates/directorate-of-gender-issues" element={<DirectorateofGender />} />
        <Route path="/directorates/directorate-of-information-and-technological-services-its-" element={<DirectorateofIts />} />
        <Route path="/directorates/directorate-of-public-procurement" element={<DirectorateofProcurement />} />
        <Route path="/directorates/directorate-of-physical-planning-and-development-ppd-" element={<DirectorateofPPD />} />
        <Route path="/directorates/directorate-of-works-and-services" element={<DirectorateofWork />} />
        <Route path="/directorates/directorate-of-academic-planning-unit" element={<DirectorateofAPU />} />
        <Route path="/directorates/directorate-of-student-industrial-placement-unit-ipu-" element={<DirectorateofIPU />} />

        {/*Quick Links*/}
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/alumni" element={<AlumniPortal />} />
        <Route path="/alumni/:slug" element={<AlumniDetail />} />
        <Route path="/apply" element={<AdmissionsPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/digital-library" element={<LibraryPage pageTitle="Digital Library" pageDescription="Access online databases, e-books, journals, repositories and digital academic resources." />} />
        <Route path="/e-library" element={<LibraryPage pageTitle="E-Library" pageDescription="Explore electronic books, journals, databases and online learning resources." />} />
        <Route path="/elibrary" element={<LibraryPage pageTitle="E-Library" pageDescription="Explore electronic books, journals, databases and online learning resources." />} />
        <Route path="/physical-library" element={<LibraryPage initialTab="hours" pageTitle="Physical Library" pageDescription="Find library opening hours, study spaces, book borrowing support and in-person library services." />} />
        <Route path="/research-collection" element={<LibraryPage initialTab="databases" pageTitle="Research Collection" pageDescription="Browse research databases, repositories, scholarly collections and academic discovery platforms." />} />
        <Route path="/e-books-and-journals" element={<LibraryPage initialTab="openaccess" pageTitle="E-Books & Journals" pageDescription="Access electronic books, academic journals, open access resources and scholarly publications." />} />
        <Route path="/e-books-journals" element={<LibraryPage initialTab="openaccess" pageTitle="E-Books & Journals" pageDescription="Access electronic books, academic journals, open access resources and scholarly publications." />} />
        <Route path="/thesis-and-dissertations" element={<LibraryPage initialTab="openaccess" searchPreset="thesis" pageTitle="Thesis & Dissertations" pageDescription="Discover thesis, dissertations and postgraduate research resources from open scholarly collections." />} />
        <Route path="/thesis-dissertations" element={<LibraryPage initialTab="openaccess" searchPreset="thesis" pageTitle="Thesis & Dissertations" pageDescription="Discover thesis, dissertations and postgraduate research resources from open scholarly collections." />} />
        <Route path="/reference-materials" element={<LibraryPage initialTab="citation" pageTitle="Reference Materials" pageDescription="Use citation tools, reference guides, dictionaries and academic writing support materials." />} />

        <Route path="/notice-board" element={<NoticeBoard />} />
        <Route path="/notice-board/:slug" element={<NoticeDetail />} />
        <Route path="/programme-finder" element={<ProgrammeFinder />} />
        <Route path="/admission-eligibility-checker" element={<AdmissionEligibilityChecker />} />
        <Route path="/downloads" element={<DownloadCenter />} />
        <Route path="/staff" element={<StaffDirectory />} />
        <Route path="/staff/:slug" element={<StaffDetail />} />
        <Route path="/help-desk" element={<HelpDesk />} />
        <Route path="/campus-map" element={<CampusMap />} />
        <Route path="/media-gallery" element={<MediaGallery />} />
        <Route path="/virtual-tour" element={<VirtualTour />} />
        <Route path="/partnerships" element={<PartnershipsPage />} />
        <Route path="/projects" element={<ProjectTracker />} />
        <Route path="/projects/:slug" element={<TetfundProjectDetailEnhanced />} />
        <Route path="/research" element={<ResearchPortal />} />
        <Route path="/research-papers" element={<ResearchResourcePage type="research-papers" />} />
        <Route path="/student-projects" element={<ResearchResourcePage type="student-projects" />} />
        <Route path="/conference-proceedings" element={<ResearchResourcePage type="conference-proceedings" />} />
        <Route path="/research-paper" element={<ResearchResourcePage type="research-papers" />} />
        <Route path="/student-project" element={<ResearchResourcePage type="student-projects" />} />
        <Route path="/conference-proceeding" element={<ResearchResourcePage type="conference-proceedings" />} />
        <Route path="/journals" element={<ResearchPortal />} />
        <Route path="/journals/:slug" element={<JournalIssueDetail />} />
        <Route path="/journals/article/:slug" element={<JournalArticleDetail />} />
        <Route path="/search" element={<AdvancedSearch />} />
        <Route path="/legacy-search" element={<SiteSearch />} />
        <Route path="/sitemap" element={<SitemapPage />} />

        <Route path="/adxm/login" element={<AdminLogin />} />
        <Route path="/adxm/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/adxm/notices" element={<ProtectedRoute><NoticesManager /></ProtectedRoute>} />
        <Route path="/departments" element={<InstitutionalDirectory pageType="department" />} />
        <Route path="/departments/:slug" element={<InstitutionalDetail pageType="department" />} />
        <Route path="/centers" element={<InstitutionalDirectory pageType="center" />} />
        <Route path="/centers/:slug" element={<InstitutionalDetail pageType="center" />} />
        <Route path="/directorates" element={<InstitutionalDirectory pageType="directorate" />} />
        <Route path="/directorates/:slug" element={<InstitutionalDetail pageType="directorate" />} />
        <Route path="/units" element={<InstitutionalDirectory pageType="unit" />} />
        <Route path="/units/:slug" element={<InstitutionalDetail pageType="unit" />} />

        
        <Route path="/adxm/institutional-pages" element={<ProtectedRoute><AdminInstitutionalPageList /></ProtectedRoute>} />
        <Route path="/adxm/institutional-pages/create" element={<ProtectedRoute><AdminInstitutionalPageForm /></ProtectedRoute>} />
        <Route path="/adxm/institutional-pages/edit/:id" element={<ProtectedRoute><AdminInstitutionalPageForm /></ProtectedRoute>} />
        <Route path="/adxm/centers" element={<ProtectedRoute><AdminInstitutionalPageList fixedType="center" /></ProtectedRoute>} />
        <Route path="/adxm/directorates" element={<ProtectedRoute><AdminInstitutionalPageList fixedType="directorate" /></ProtectedRoute>} />
        <Route path="/adxm/units" element={<ProtectedRoute><AdminInstitutionalPageList fixedType="unit" /></ProtectedRoute>} />
        <Route path="/adxm/departments" element={<ProtectedRoute><AdminDepartmentList /></ProtectedRoute>} />
        <Route path="/adxm/departments/create" element={<ProtectedRoute><AdminDepartmentForm /></ProtectedRoute>} />
        <Route path="/adxm/departments/edit/:id" element={<ProtectedRoute><AdminDepartmentForm /></ProtectedRoute>} />
        <Route path="/adxm/downloads" element={<ProtectedRoute><AdminDownloadList /></ProtectedRoute>} />
        <Route path="/adxm/downloads/create" element={<ProtectedRoute><AdminDownloadForm /></ProtectedRoute>} />
        <Route path="/adxm/downloads/edit/:id" element={<ProtectedRoute><AdminDownloadForm /></ProtectedRoute>} />
        <Route path="/adxm/staff" element={<ProtectedRoute><AdminStaffList /></ProtectedRoute>} />
        <Route path="/adxm/staff/create" element={<ProtectedRoute><AdminStaffForm /></ProtectedRoute>} />
        <Route path="/adxm/staff/edit/:id" element={<ProtectedRoute><AdminStaffForm /></ProtectedRoute>} />
        <Route path="/adxm/campus-locations" element={<ProtectedRoute><AdminCampusLocationList /></ProtectedRoute>} />
        <Route path="/adxm/campus-locations/create" element={<ProtectedRoute><AdminCampusLocationForm /></ProtectedRoute>} />
        <Route path="/adxm/campus-locations/edit/:id" element={<ProtectedRoute><AdminCampusLocationForm /></ProtectedRoute>} />
        <Route path="/adxm/gallery-albums" element={<ProtectedRoute><AdminGalleryAlbumList /></ProtectedRoute>} />
        <Route path="/adxm/gallery-albums/create" element={<ProtectedRoute><AdminGalleryAlbumForm /></ProtectedRoute>} />
        <Route path="/adxm/gallery-albums/edit/:id" element={<ProtectedRoute><AdminGalleryAlbumForm /></ProtectedRoute>} />
        <Route path="/adxm/gallery-media" element={<ProtectedRoute><AdminGalleryMediaList /></ProtectedRoute>} />
        <Route path="/adxm/gallery-media/create" element={<ProtectedRoute><AdminGalleryMediaForm /></ProtectedRoute>} />
        <Route path="/adxm/gallery-media/edit/:id" element={<ProtectedRoute><AdminGalleryMediaForm /></ProtectedRoute>} />
        <Route path="/adxm/journal-issues" element={<ProtectedRoute><AdminJournalIssueList /></ProtectedRoute>} />
        <Route path="/adxm/journal-issues/create" element={<ProtectedRoute><AdminJournalIssueForm /></ProtectedRoute>} />
        <Route path="/adxm/journal-issues/edit/:id" element={<ProtectedRoute><AdminJournalIssueForm /></ProtectedRoute>} />
        <Route path="/adxm/journal-articles" element={<ProtectedRoute><AdminJournalArticleList /></ProtectedRoute>} />
        <Route path="/adxm/journal-articles/create" element={<ProtectedRoute><AdminJournalArticleForm /></ProtectedRoute>} />
        <Route path="/adxm/journal-articles/edit/:id" element={<ProtectedRoute><AdminJournalArticleForm /></ProtectedRoute>} />
        <Route path="/adxm/alumni" element={<ProtectedRoute><AdminAlumniList /></ProtectedRoute>} />
        <Route path="/adxm/alumni/create" element={<ProtectedRoute><AdminAlumniForm /></ProtectedRoute>} />
        <Route path="/adxm/alumni/edit/:id" element={<ProtectedRoute><AdminAlumniForm /></ProtectedRoute>} />
        <Route path="/adxm/partnerships" element={<ProtectedRoute><AdminPartnershipList /></ProtectedRoute>} />
        <Route path="/adxm/partnerships/create" element={<ProtectedRoute><AdminPartnershipForm /></ProtectedRoute>} />
        <Route path="/adxm/partnerships/edit/:id" element={<ProtectedRoute><AdminPartnershipForm /></ProtectedRoute>} />
        <Route path="/adxm/projects" element={<ProtectedRoute><AdminProjectList /></ProtectedRoute>} />
        <Route path="/adxm/tetfund-projects" element={<ProtectedRoute><AdminProjectList /></ProtectedRoute>} />
        <Route path="/adxm/tetfund-projects/create" element={<ProtectedRoute><AdminProjectForm /></ProtectedRoute>} />
        <Route path="/adxm/tetfund-projects/edit/:id" element={<ProtectedRoute><AdminProjectForm /></ProtectedRoute>} />
        <Route path="/adxm/projects/create" element={<ProtectedRoute><AdminProjectForm /></ProtectedRoute>} />
        <Route path="/adxm/projects/edit/:id" element={<ProtectedRoute><AdminProjectForm /></ProtectedRoute>} />
        <Route path="/adxm/support-tickets" element={<ProtectedRoute><SupportTicketsManager /></ProtectedRoute>} />
        <Route path="/adxm/seo" element={<ProtectedRoute><AdminSeoPageList /></ProtectedRoute>} />
        <Route path="/adxm/seo/create" element={<ProtectedRoute><AdminSeoPageForm /></ProtectedRoute>} />
        <Route path="/adxm/seo/edit/:id" element={<ProtectedRoute><AdminSeoPageForm /></ProtectedRoute>} />
        <Route path="/adxm/analytics" element={<ProtectedRoute><AdminAnalyticsDashboard /></ProtectedRoute>} />
        <Route path="/adxm/security" element={<ProtectedRoute><AdminSecurityDashboard /></ProtectedRoute>} />
        <Route path="/adxm/audit-logs" element={<ProtectedRoute><AdminAuditLogs /></ProtectedRoute>} />
        <Route path="/adxm/backups" element={<ProtectedRoute><AdminBackupRestore /></ProtectedRoute>} />
        <Route path="/adxm/admin-users" element={<ProtectedRoute><AdminUsersList /></ProtectedRoute>} />
        <Route path="/adxm/admin-users/create" element={<ProtectedRoute><AdminUserForm /></ProtectedRoute>} />
        <Route path="/adxm/admin-users/edit/:id" element={<ProtectedRoute><AdminUserForm /></ProtectedRoute>} />
        <Route path="/adxm/navigation" element={<ProtectedRoute><AdminNavigationList /></ProtectedRoute>} />
        <Route path="/adxm/navigation/create" element={<ProtectedRoute><AdminNavigationForm /></ProtectedRoute>} />
        <Route path="/adxm/navigation/edit/:id" element={<ProtectedRoute><AdminNavigationForm /></ProtectedRoute>} />
        <Route path="/adxm/content-approvals" element={<ProtectedRoute><AdminContentApprovals /></ProtectedRoute>} />
        <Route path="/adxm/search-insights" element={<ProtectedRoute><AdminSearchInsights /></ProtectedRoute>} />
        <Route path="/adxm/ui-ux" element={<ProtectedRoute><AdminUiUxCenter /></ProtectedRoute>} />

        {/*Header*/}
        <Route path="/about" element={<About />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/polymath-journal" element={<ResearchPortal />}/>
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/adxm/news" element={<ProtectedRoute><AdminNewsList /></ProtectedRoute>} />
        <Route path="/adxm/news/create" element={<ProtectedRoute><AdminNewsForm /></ProtectedRoute>} />
        <Route path="/adxm/news/edit/:id" element={<ProtectedRoute><AdminNewsForm /></ProtectedRoute>} />
        <Route path="/tetfund-projects" element={<TetfundProjectsEnhanced />} />
        <Route path="/tetfund-projects/:slug" element={<TetfundProjectDetailEnhanced />} />
        <Route path="/poly-consult" element={<Consults />} />
        <Route path="/gallery" element={<MediaGallery />} />
        <Route path="/legacy-gallery" element={<GalleryPage />} />
        <Route path="/adxm/events" element={<ProtectedRoute><AdminEventsList /></ProtectedRoute>} />
        <Route path="/adxm/events/create" element={<ProtectedRoute><AdminEventsForm /></ProtectedRoute>} />
        <Route path="/adxm/events/edit/:id" element={<ProtectedRoute><AdminEventsForm /></ProtectedRoute>} />
        <Route path="/adxm/manage-events" element={<ProtectedRoute><AdminEventsList /></ProtectedRoute>} />
        <Route path="/schools" element={<Schools />} />
        <Route path="*" element={<NotFounds />} />

      </Routes>
      {/*Footer*/}
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <PWAInstallPrompt />}
      {!isAdminRoute && <AccessibilityToolbar />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
